import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Button,
  Input,
  Flex,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useToast,
  useColorModeValue,
  useBreakpointValue,
  Text,
  FormControl,
  FormLabel,
  InputGroup,
  InputRightElement,
  Badge,
  Switch
 }from "@chakra-ui/react";
import { MdEdit, MdDelete, MdDone, MdCancel, MdAdd, MdVisibility, MdVisibilityOff } from "react-icons/md";
import Card from "components/card/Card";
import fetchWithToken from "views/auth/signIn/axiosInstance";
import CreateUser from "views/admin/Users/components/CreateUser";
import { useTranslation } from "react-i18next";
import { from } from "stylis";
import ReactSelect from "react-select";

const UsersList = () => {
  const [showPassword, setShowPassword] = useState(false);
  // Dummy branches and currentUserRoleId for demonstration; replace with real data as needed

  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [editableUser, setEditableUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const toast = useToast();
  const [updateUser, setupdateUser] = useState(null);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const modalSize = useBreakpointValue({ base: "full", md: "xl" });
  const textColor = useColorModeValue("secondaryGray.900", "white");
const [showEditUserModal, setShowEditUserModal] = useState(false);
  const pageId= 17;
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage, setOrdersPerPage] = useState(10); // Now controlled by select
  // Calculate total pages based on filteredUsers
const [totalPages, setTotalPages] = useState(1);
const [companies, setCompanies] = useState([]);
const [loadingCompanies, setLoadingCompanies] = useState(false);
const [companyId, setCompanyId] = useState("");
const [showCompanyFilter, setShowCompanyFilter] = useState(true); // Set to true to show filter


// ...existing code...
  // Get current page's users
 const filteredOrders = filteredUsers;
  const [permissions, setPermissions] = useState({ canList: true, canEdit: true, canDelete: true, canInsert: true });
  const toggleCreateUserModal = () => {
    setShowCreateUserModal(!showCreateUserModal);
  };
  useEffect(() => {
    try {
      const role = JSON.parse(sessionStorage.getItem("permissions") || "{}");
      if (!role.permissions) {
        toast({
          title: "No permissions found",
          description: "You don't have the required access.",
          status: "error",
          duration: 3000,
          isClosable: true,
position: "top-right",

        });
        return;
      }

      const permission = role.permissions.find((p) => p.page_id === 17);
      if (permission) {
        setPermissions({
          canList: permission.read_all_access || false,
          canEdit: permission.update_access || false,
          canDelete: permission.delete_access || false,
          canInsert: permission.insert_access || false,
        });
      }
    } catch (error) {
      toast({
        title: "Error loading permissions",
        description: error.message || "Something went wrong while fetching permissions.",
        status: "error",
        duration: 3000,
        isClosable: true,
position: "top-right",

      });
    }
  }, []);
  

// Edit button handler
const handleEditUser = (user) => {
  setEditableUser({
    ...user,
    roleId: user.role?.id || user.roleId,
  });
  setShowEditUserModal(true);
};

// Save handler
const handleSaveUser = async () => {
  try {
    const data = {
      id: editableUser.id,
      first_name: editableUser.first_name,
      last_name: editableUser.last_name,
      email: editableUser.email,
      ...(editableUser.password && { password: editableUser.password }),
      role_id: parseInt(editableUser.roleId, 10),
      updateUser: updateUser,
      page_id: pageId,
    };
    const response = await fetchWithToken(
      `${process.env.REACT_APP_API_URL}/users/user`,
      "PATCH",
      data
    );
    if (!response || response.status !== "success") {
      throw new Error(response.message || "Failed to update user");
    }
  setUsers((prev) => prev.map((u) => (u.id === editableUser.id ? { ...u, ...data, role: roles.find(r => r.role_id === data.role_id) } : u)));
  setFilteredUsers((prev) => prev.map((u) => (u.id === editableUser.id ? { ...u, ...data, role: roles.find(r => r.role_id === data.role_id) } : u)));
    setEditableUser(null);
    setShowEditUserModal(false);
    toast({
      title: "Success",
      description: "User updated successfully.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    //  window.location.reload();
  } catch (error) {
    toast({
      title: "Error updating user.",
      description: error.message || "Failed to update user",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  }
};

// Close modal handler
const handleEditFormClose = () => {
  setEditableUser(null);
  setShowEditUserModal(false);
};

  const handleDeleteUser = async (userId) => {
    try {
      const response = await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/user/delete?id=${userId}&page_id=${pageId}`,
        "DELETE"
      );

      if (!response) {
        throw new Error("Failed to delete user");
      }

      setUsers((prevUsers) =>
        prevUsers.filter((user) => user.userId !== userId)
      );
      setFilteredUsers((prevFilteredUsers) =>
        prevFilteredUsers.filter((user) => user.userId !== userId)
      );
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchTerm(query);
  };

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    if (accessToken) {
      const [header, payload, signature] = accessToken.split(".");
      const decodedPayload = JSON.parse(atob(payload));
      const updateUser = decodedPayload.clientId;
      setupdateUser(updateUser);
    } else {
      console.error("Access token not found.");
    }
  }, []);
useEffect(() => {
  if (!showCompanyFilter) return;
  setLoadingCompanies(true);
  const fetchCompanies = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL2}/companies/all?page_id=${pageId}`;
      const data = await fetchWithToken(url, "GET");
      if (data.status === "error") throw new Error(data.message || "Error fetching companies");
      setCompanies(data.data);
    } catch (error) {
      toast({
        title: t("Error"),
        description: error.message,
        status: "error",
        position: "top-right",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingCompanies(false);
    }
  };
  fetchCompanies();
}, [showCompanyFilter, t, toast]);
  useEffect(() => {
  const fetchUsers = async () => {
    try {
      let url = `${process.env.REACT_APP_API_URL}/users?page_id=${pageId}&page=${currentPage}&limit=${ordersPerPage}`;
      if (companyId) {
        url += `&company_id=${companyId}`;
      }
      const responseUsers = await fetchWithToken(url);
      const responseRoles = await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/roles?page_id=${pageId}`
      );

      if (responseUsers && responseRoles) {
        setUsers(responseUsers.data);
        setRoles(responseRoles.data);
        // Use meta.last_page from API for totalPages
        if (responseUsers.meta) {
          setTotalPages(responseUsers.meta.last_page || 1);
        }
      } else {
        console.error("Error fetching users or roles");
      }
    } catch (error) {
      console.error("Error fetching users or roles:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchUsers();
}, [currentPage, ordersPerPage, companyId]);

  useEffect(() => {
    const filteredResults = users.filter((user) => {
      const firstName = user.first_name ? user.first_name.toLowerCase() : "";
      const lastName = user.last_name ? user.last_name.toLowerCase() : "";

      const searchTermLower = searchTerm.toLowerCase();
  
      return firstName.includes(searchTermLower) || lastName.includes(searchTermLower) ||
        user.email.toLowerCase().includes(searchTermLower) ;
    });
    setFilteredUsers(filteredResults);
  }, [searchTerm, users]);
  
  return (
    <Card direction="column" w="100%" px="0px" overflowX={{ sm: "scroll", lg: "hidden" }} boxShadow="lg">
      <Box
        overflowY="auto"
        maxHeight="400px"
        px="25px"
        mb="20px"
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ base: "flex-start", md: "center" }}
      >
        <Flex alignItems="center" mb={{ base: 4, md: 0 }}>
          <Text color="gray.800" fontSize={{ base: "18px", md: "22px" }} fontWeight="700" lineHeight="100%" mb={{ base: "10px", md: "0" }}>
            {t("Users List")}
          </Text>
          <Button
            onClick={toggleCreateUserModal}
            isDisabled={!permissions.canInsert}
            mb={1}
            ml={4}
            colorScheme="cyan"
            color="white"
            borderRadius="full"
            boxShadow="sm"
            _hover={{ bg: "cyan.600", transform: "scale(1.05)" }}
            _active={{ bg: "cyan.700", transform: "scale(0.95)" }}
            transition="all 0.2s"
          >
            <MdAdd />
          </Button>
        </Flex>
       <Flex alignItems="center" gap={4} mb={{ base: 4, md: 0 }} ml="auto" mr={"4px"}>
  <FormControl maxW={{ base: "100%", md: "200px" }} display={showCompanyFilter ? "block" : "none"}>
    {showCompanyFilter && (
      <Select
        value={companyId === undefined || companyId === null ? "all" : companyId}
        onChange={(e) => {
          const val = e.target.value;
          setCompanyId(val === "all" ? "" : val);
        }}
        size="sm"
        maxW="200px"
        isDisabled={loadingCompanies}
        focusBorderColor="blue.400"
        _hover={{
          borderColor: "blue.400",
          boxShadow: "0 0 0 1px #3182CE",
          color: "blue.400",
          backgroundColor: "blue.50",
        }}
      >
        <option value="all">{t("All Companies")}</option>
        {loadingCompanies ? (
          <option disabled>{t("Loading...")}</option>
        ) : (
          companies.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name || `Company ${c.id}`}
            </option>
          ))
        )}
      </Select>
    )}
  </FormControl>
  <FormControl maxW={{ base: "100%", md: "120px" }}>
    <Select
      value={ordersPerPage}
      onChange={(e) => {
        setOrdersPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
      }}
      size="sm"
      focusBorderColor="blue.400"
      borderRadius={"md"}
      _hover={{
        borderColor: "blue.400",
        boxShadow: "0 0 0 1px #3182CE",
        color: "blue.400",
        backgroundColor: "blue.50"
      }}
    >
      <option value="10">10 {t("per page")}</option>
      <option value="20">20 {t("per page")}</option>
      <option value="50">50 {t("per page")}</option>
    </Select>
  </FormControl>
</Flex>
       
        <Input
          placeholder={t("Search by name")}
          value={searchTerm}
          onChange={handleSearch}
          size="sm"
          w={{ base: "100%", md: "200px" }}
        />
      </Box>
      <Box px="20px">
 <Box  overflowY="auto" maxHeight="400px" px="20px">
            {loading ? (
            <Spinner size="xl" />
          ) : (
        
               <Table variant="striped" colorScheme="gray">
                 <Thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                      <Tr bg='rgb(69, 50, 240)' textColor="white" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
      <Th textColor="white">{t("Index")}</Th>
      <Th textColor="white">{t("First Name")}</Th>
      <Th textColor="white">{t("Last Name")}</Th>
      <Th textColor="white">{t("Email")}</Th>
      <Th textColor="white">{t("Role")}</Th>
      <Th textColor="white">{t("Company Name")}</Th>
      <Th textColor="white">{t("Status")}</Th>
      <Th textColor="white">{t("Actions")}</Th>
    </Tr>
  </Thead>
  <Tbody>
    {filteredOrders.map((user, index) => (
      <Tr key={user.id}>
        <Td>{(currentPage - 1) * ordersPerPage + index + 1}</Td>
        <Td>{user.first_name}</Td>
        <Td>{user.last_name}</Td>
        <Td>{user.email}</Td>
        <Td>{user.role?.name}</Td>
        <Td>{user.company_name || "-"}</Td>
        <Td>
          <Badge
            colorScheme={user && user.status === true ? "green" : "red"}
            variant="solid"
            px={2}
            py={1}
            borderRadius="md"
            fontSize="0.85em"
          >
            {user && user.status === true ? t("Active") : t("Inactive")}
          </Badge>
        </Td>
        <Td>
          <Flex>
          <Button
            colorScheme="cyan"
            size="sm"
            isDisabled={!permissions.canEdit}
            color={"white"}
            onClick={() => handleEditUser(user)}
            leftIcon={<MdEdit />}
          >
            {t("Edit")}
          </Button>
          </Flex>
        </Td>
      </Tr>
    ))}
  </Tbody>
</Table>
        )}
      </Box>
       {/* Pagination Controls */}
        {totalPages > 0 && (
          <Box mt={4} mb={4}>
            {/* Pagination Info */}
            <Text textAlign="center" fontSize="sm" color="gray.600" mb={3}>
              {t("Page")} {currentPage} {t("of")} {totalPages} 
              {filteredOrders.length > 0 && (
                <span> - {t("Showing")} {((currentPage - 1) * ordersPerPage) + 1} {t("to")} {Math.min(currentPage * ordersPerPage, ((currentPage - 1) * ordersPerPage) + filteredOrders.length)} {t("results")}</span>
              )}
            </Text>
            
            {/* Pagination Buttons */}
            <Flex justifyContent="center" wrap="wrap" gap={2}>
              {/* First Page */}
              <Button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                size="sm"
                variant="outline"
                display={{ base: currentPage > 3 ? "block" : "none", md: currentPage > 2 ? "block" : "none" }}
              >
                {t("First")}
              </Button>
              
              {/* Previous Page */}
              <Button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                size="sm"
                colorScheme="cyan"
                variant="outline"
              >
                {t("Previous")}
              </Button>

              {/* Page Numbers with smart ellipsis */}
              {(() => {
                const delta = 2; // Number of pages to show around current page
                const range = [];
                const rangeWithDots = [];

                for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
                  range.push(i);
                }

                if (currentPage - delta > 2) {
                  rangeWithDots.push(1, '...');
                } else {
                  rangeWithDots.push(1);
                }

                rangeWithDots.push(...range);

                if (currentPage + delta < totalPages - 1) {
                  rangeWithDots.push('...', totalPages);
                } else if (totalPages > 1) {
                  rangeWithDots.push(totalPages);
                }

                return rangeWithDots.map((page, index) => {
                  if (page === '...') {
                    return (
                      <Text key={`ellipsis-${index}`} mx={2} alignSelf="center" fontSize="sm" color="gray.500">
                        ...
                      </Text>
                    );
                  }

                  return (
                    <Button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      variant={currentPage === page ? "solid" : "outline"}
                      colorScheme={currentPage === page ? "cyan" : "gray"}
                      color={'blue'}
                      size="sm"
                      minW="40px"
                    >
                      {page}
                    </Button>
                  );
                });
              })()}

              {/* Next Page */}
              <Button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                size="sm"
                colorScheme="cyan"
                variant="outline"
              >
                {t("Next")}
              </Button>

              {/* Last Page */}
              <Button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                size="sm"
                variant="outline"
                display={{ base: currentPage < totalPages - 2 ? "block" : "none", md: currentPage < totalPages - 1 ? "block" : "none" }}
              >
                {t("Last")}
              </Button>
            </Flex>
          </Box>
        )}
      </Box>
      <Modal isOpen={showCreateUserModal} onClose={toggleCreateUserModal} size={modalSize}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text color={textColor} fontSize="2xl" fontWeight="700">
              {t("Create User")}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <CreateUser />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={toggleCreateUserModal}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Edit User Modal */}
<Modal isOpen={showEditUserModal} onClose={handleEditFormClose} size={modalSize}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text color={textColor} fontSize="3xl" fontWeight="700">
              {t("Edit User")}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editableUser && (
              <Box as="form">
                <FormControl>
                  <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
                    {t("First Name")}
                  </FormLabel>
                  <Input
                    isRequired
                    type="text"
                    placeholder={t("First Name")}
                    mb="24px"
                    size="lg"
                    value={editableUser.first_name}
                    onChange={(e) =>
                      setEditableUser({
                        ...editableUser,
                        first_name: e.target.value,
                      })
                    }
                  />
                  <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
                    {t("Last Name")}
                  </FormLabel>
                  <Input
                    isRequired
                    type="text"
                    placeholder={t("Last Name")}
                    mb="24px"
                    size="lg"
                    value={editableUser.last_name}
                    onChange={(e) =>
                      setEditableUser({
                        ...editableUser,
                        last_name: e.target.value,
                      })
                    }
                  />
                  <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
                    {t("Email")}
                  </FormLabel>
                  <Input
                    isDisabled
                    type="email"
                    placeholder={t("Email")}
                    mb="24px"
                    size="lg"
                    value={editableUser.email}
                    onChange={(e) =>
                      setEditableUser({
                        ...editableUser,
                        email: e.target.value,
                      })
                    }
                  />
                  <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
                    {t("Password")}
                  </FormLabel>
                  <InputGroup mb="24px" size="lg">
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder={t("Password (leave blank to keep unchanged)")}
                      value={editableUser.password || ""}
                      onChange={(e) =>
                        setEditableUser({
                          ...editableUser,
                          password: e.target.value,
                        })
                      }
                      pr="40px"
                    />
                    <InputRightElement width="3rem">
                      <Button
                        h="1.75rem"
                        size="sm"
                        variant="ghost"
                        onClick={() => setShowPassword((show) => !show)}
                        tabIndex={-1}
                      >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                  <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">
                    {t("Role")}
                  </FormLabel>
                  <Select
                isDisabled
          placeholder={t("Select Role")}
          mb="24px"
          size="lg"
          value={editableUser.roleId}
          onChange={(e) =>
            setEditableUser({
              ...editableUser,
              roleId: e.target.value,
            })
          }
        >
         {roles.map((role) => (
            <option key={role.role_id} value={role.role_id}>
              {role.role_name}
            </option>
          ))}
        </Select>

                  <FormLabel fontSize="sm" fontWeight="500" mb="8px" color="blue.600">{t("Status")}</FormLabel>
                  {typeof editableUser.status === 'boolean' ? (
                    <>
                      <Switch
                        isChecked={editableUser.status}
                        onChange={e => setEditableUser({
                          ...editableUser,
                          status: e.target.checked
                        })}
                        colorScheme="cyan"
                        mr={2}
                      />
                      <Box as="span">
                        <Badge
                          colorScheme={editableUser.status ? "green" : "red"}
                          variant="solid"
                          px={2}
                          py={1}
                          borderRadius="md"
                          fontSize="0.85em"
                        >
                          {editableUser.status ? t("Active") : t("Inactive")}
                        </Badge>
                      </Box>
                    </>
                  ) : (
                    <Badge colorScheme="gray" variant="subtle">{t(editableUser.status)}</Badge>
                  )}
                </FormControl>
              </Box>
            )}
          </ModalBody>
         <ModalFooter>
      <Button colorScheme="cyan" mr={3} onClick={handleSaveUser} leftIcon={<MdDone />}>
        {t("Save")}
      </Button>
      <Button colorScheme="red" onClick={handleEditFormClose}>
        {t("Cancel")}
      </Button>
    </ModalFooter>
        </ModalContent>
      </Modal>
    </Card>
  );
};

export default UsersList;
